import { render } from "./IconChevronDownSmall.vue?vue&type=template&id=109babb9"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronDownSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "109babb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('109babb9', __exports__)) {
    api.reload('109babb9', __exports__)
  }
  
  module.hot.accept("./IconChevronDownSmall.vue?vue&type=template&id=109babb9", () => {
    api.rerender('109babb9', render)
  })

}


export default __exports__